import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🏰", key: "royal" },
  { emoji: "📸", key: "studio" },
  { emoji: "🌿", key: "outdoor" },
  { emoji: "✨", key: "fantasy" },
]

export default function PetsPetCountPage() {
  return <RadioCardListPage translationKey="petsPetCount" options={OPTIONS} />
}
